<template>
  <QS-scroller-box>
    <form-text-box
       ref="baseInfoInfo"
       :column="3"
       :dataList="renderData.list.selectOrderFormList"
       :model="renderData.model.selectOrderFormModel"
       :rules="renderData.rules.selectOrderFormRules"
     />
     <el-divider></el-divider>
     <form-text-box
       :column="3"
       :dataList="renderData.list.selectOrderTextList"
       :model="renderData.model.selectOrderTextModel"
     />
     <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="confirm" size="mini" type="primary">确认，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>

<script>
import {
  searchByCustomerName,
} from '@/api/domain/customers'

export default {
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  created() {
    this.getRouteQuery()
  },
  methods: {
    getRouteQuery() {
      const { customerId, customerName } = this.$route.query
      if (customerId) {
        this.customerNameRemoteMethod(customerName, customerId)
      } else {
        searchByCustomerName({
          customerType: 2,
          customerState: 1, // 客户状态 0禁用 1启用
        }).then((res) => {
          const { data } = res
          this.$refs.baseInfoInfo.setItemData({ elConfigKey: 'list', key: 'customerId', data: data || [] })
        })
      }
    },

    // 客户姓名模糊搜索
    customerNameRemoteMethod(val, id = '') {
      if (typeof val !== 'string') return
      if (val.trim().length < 1) return
      searchByCustomerName({
        customerName: val.trim(),
        customerType: 2,
        customerState: 1, // 客户状态 0禁用 1启用
      }).then((res) => {
        const { data } = res
        this.$refs.baseInfoInfo.setItemData({ elConfigKey: 'list', key: 'customerId', data: data || [] })
        // 设置回显初始值
        if (id || this.renderData.model.selectOrderFormModel.customerId) {
          const currentId = id || this.renderData.model.selectOrderFormModel.customerId
          this.$set(this.renderData.model.selectOrderFormModel, 'customerId', Number(currentId))
        }
      })
    },
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      const { selectOrderFormModel: { customerId, entRentOrderId } } = this.renderData.model
      if (!customerId) {
        this.$message.error('请先选择客户')
        return
      }
      if (!entRentOrderId) {
        this.$message.error('请选择主订单ID')
        return
      }
      this.$emit('confirm')
    },
  },
}
</script>
